import React, { useEffect, useMemo, useRef, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  IconButton,
  Box,
  MenuItem,
  Popover,
  Tooltip,
  MenuList,
  Typography,
  Link,
  Modal,
  Button,
} from "@material-ui/core";
import axios from "axios";
import OutlineIconButton from "../components/OutlineIconButton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useMeeting } from "@videosdk.live/react-sdk";
import { sideBarModes, useMeetingAppContext } from "../MeetingAppContextDef";
import useIsTab from "../utils/useIsTab";
import useIsMobile from "../utils/useIsMobile";
import ReactSpeedometer from "react-d3-speedometer";
import {
  Activities,
  Chat,
  EndCall,
  Participants,
  ScreenRecording,
  ScreenShare,
  RaiseHand,
  LeaveMeetingIcon,
  EndCallIcon,
} from "../icons";

import {
  MicOff as MicOffIcon,
  Mic as MicIcon,
  VideocamOff as VideocamOffIcon,
  Videocam as VideocamIcon,
  MoreHoriz as MoreHorizIcon,
  Close as CloseIcon,
  ArrowDropDown as ArrowDropDownIcon,
  Gesture as Gesture,
  Crop,
  NetworkWifi,
  FeaturedVideo,
  Share,
} from "@material-ui/icons";

import {
  isMobile as RDDIsMobile,
  isTablet as RDDIsTablet,
} from "react-device-detect";
import ConfirmBox from "../components/ConfirmBox";
import { useMediaQuery } from "react-responsive";
import { toast } from "material-react-toastify";
import { useLocation, useSearchParams } from "react-router-dom";

import jwt_decode from "jwt-decode";
const useStyles = makeStyles({
  row: { display: "flex", alignItems: "center" },
  borderRight: { borderRight: "1ps solid #ffffff33" },
  popover: { backgroundColor: "transparent" },
  popoverBorder: {
    borderRadius: "12px",
    backgroundColor: "#212032",
    marginTop: 8,
    width: 300,
  },
  totalSpeed: {
    color: "white",
    fontSize: "15px",
    textAlign: "center",
    fontWeight: "bold",
  },
});
const RaiseHandBTN = ({ onClick }) => {
  const mMeeting = useMeeting();

  const sendChatMessage = mMeeting?.sendChatMessage;

  const onRaiseHand = () => {
    typeof onClick === "function" && onClick();
    sendChatMessage(JSON.stringify({ type: "RAISE_HAND", data: {} }));
  };

  return (
    <Tooltip>
      <OutlineIconButton
        tooltipTitle={"Raise hand"}
        Icon={RaiseHand}
        onClick={onRaiseHand}
      />
    </Tooltip>
  );
};
const ParticipantsBTN = ({ onClick }) => {
  const { sideBarMode, setSideBarMode } = useMeetingAppContext();

  const mMeeting = useMeeting();
  const participants = mMeeting?.participants;
  const participantsCount = participants ? new Map(participants).size : 0;

  return (
    <OutlineIconButton
      tooltipTitle={"Participants"}
      isFocused={sideBarMode === sideBarModes.PARTICIPANTS}
      Icon={Participants}
      onClick={() => {
        typeof onClick === "function" && onClick();
        setSideBarMode((s) =>
          s === sideBarModes.PARTICIPANTS ? null : sideBarModes.PARTICIPANTS
        );
      }}
      badge={participantsCount}
    />
  );
};
const ChatBTN = () => {
  const { sideBarMode, setSideBarMode } = useMeetingAppContext();
  const [messagess, setMessages] = useState([]);
  const mMeeting = useMeeting();
  const messages = mMeeting?.messages;

  useEffect(() => {
    localStorage.setItem("new", messagess?.length);
    setMessages(messages);
  }, [messages]);

  const oldMessage = isNaN(Number(localStorage.getItem("new")))
    ? 0
    : Number(localStorage.getItem("new"));
  const unreadCount = messagess?.length - oldMessage;

  return (
    <OutlineIconButton
      tooltipTitle={"Chat"}
      Icon={Chat}
      isFocused={sideBarMode === sideBarModes.CHAT}
      onClick={() => {
        localStorage.setItem("new", messagess?.length);
        setSideBarMode((s) =>
          s === sideBarModes.CHAT ? null : sideBarModes.CHAT
        );
      }}
      badge={unreadCount}
    />
  );
};
const ActivitiesBTN = ({ onClick }) => {
  const { sideBarMode, setSideBarMode } = useMeetingAppContext();

  return (
    <OutlineIconButton
      tooltipTitle={"Activities"}
      Icon={Activities}
      isFocused={sideBarMode === sideBarModes.ACTIVITIES}
      onClick={() => {
        typeof onClick === "function" && onClick();

        setSideBarMode((s) =>
          s === sideBarModes.ACTIVITIES ? null : sideBarModes.ACTIVITIES
        );
      }}
    />
  );
};

const WhiteBoardBTN = () => {
  const { whiteboardStarted, whiteboardEnabled, canToggleWhiteboard } =
    useMeetingAppContext();
  const mMeeting = useMeeting({});

  return (
    <>
      {whiteboardEnabled && (
        <OutlineIconButton
          disabled={!canToggleWhiteboard}
          tooltipTitle={"Whiteboard"}
          Icon={Gesture}
          isFocused={whiteboardStarted}
          onClick={() => {
            whiteboardStarted
              ? mMeeting.meeting.stopWhiteboard()
              : mMeeting.meeting.startWhiteboard();
          }}
        />
      )}
    </>
  );
};

const ScreenShareBTN = ({ onClick }) => {
  const mMeeting = useMeeting({});
  const { whiteboardStarted } = useMeetingAppContext();

  const localScreenShareOn = mMeeting?.localScreenShareOn;
  const toggleScreenShare = mMeeting?.toggleScreenShare;
  const presenterId = mMeeting?.presenterId;

  return (
    <OutlineIconButton
      tooltipTitle={
        presenterId
          ? localScreenShareOn
            ? "Stop Presenting"
            : null
          : "Present Screen"
      }
      isFocused={localScreenShareOn}
      Icon={ScreenShare}
      onClick={() => {
        typeof onClick === "function" && onClick();
        toggleScreenShare();
      }}
      disabled={
        RDDIsMobile || RDDIsTablet
          ? true
          : whiteboardStarted
          ? true
          : presenterId
          ? localScreenShareOn
            ? false
            : true
          : false
      }
    />
  );
};
const MicBTN = () => {
  const { selectedMic } = useMeetingAppContext();

  const [selectedDeviceId, setSelectedDeviceId] = useState(selectedMic.id);
  const [downArrow, setDownArrow] = useState(null);
  const [mics, setMics] = useState([]);
  const mMeeting = useMeeting({});
  const theme = useTheme();

  const handleClick = (event) => {
    setDownArrow(event.currentTarget);
  };

  const handleClose = () => {
    setDownArrow(null);
  };

  const localMicOn = mMeeting?.localMicOn;
  const toggleMic = mMeeting?.toggleMic;
  const changeMic = mMeeting?.changeMic;

  const getMics = async (mGetMics) => {
    const mics = await mGetMics();

    mics && mics?.length && setMics(mics);
  };

  const tollTipEl = useRef();

  return (
    <Box
      ref={tollTipEl}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <OutlineIconButton
        btnID={"btnMic"}
        tooltipTitle={localMicOn ? "Turn off mic" : "Turn on mic"}
        isFocused={localMicOn}
        Icon={localMicOn ? MicIcon : MicOffIcon}
        onClick={toggleMic}
        focusBGColor={"#ffffff33"}
        focusIconColor={theme.palette.common.white}
        renderRightComponent={() => {
          //   <Tooltip
          //   placement="bottom"
          //   title={localMicOn ? "Change microphone" : null}
          // >

          // </Tooltip>
          return (
            <IconButton
              // disabled={!localMicOn}
              onClick={(e) => {
                getMics(mMeeting.getMics);
                handleClick(e);
              }}
              size={"small"}
            >
              <ArrowDropDownIcon fontSize={"small"} />
            </IconButton>
          );
        }}
      />

      <Popover
        container={tollTipEl.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        anchorEl={tollTipEl.current}
        open={Boolean(downArrow)}
        onClose={handleClose}
      >
        <MenuList>
          {mics.map(({ deviceId, label }, index) => (
            <MenuItem
              key={`output_mics_${deviceId}`}
              selected={deviceId === selectedDeviceId}
              onClick={() => {
                handleClose();
                setSelectedDeviceId(deviceId);
                changeMic(deviceId);
              }}
            >
              {label || `Mic ${index + 1}`}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </Box>
  );
};

const RecordingBTN = () => {
  const mMeeting = useMeeting({});

  const isRecording = mMeeting?.isRecording;
  const startRecording = mMeeting?.startRecording;
  const stopRecording = mMeeting?.stopRecording;
  const [defaultRecordingActionTaken, setDefaultRecordingActionTaken] =
    useState(false);

  const {
    recordingWebhookUrl,
    autoStartRecording,
    participantCanToggleRecording,
  } = useMeetingAppContext();

  useEffect(() => {
    if (autoStartRecording) {
      setDefaultRecordingActionTaken(true);
      setTimeout(() => {
        if (!defaultRecordingActionTaken) {
          startRecording(recordingWebhookUrl);
        }
      }, 5000);
    }
  }, [
    recordingWebhookUrl,
    defaultRecordingActionTaken,
    autoStartRecording,
    startRecording,
  ]);

  return (
    <OutlineIconButton
      Icon={ScreenRecording}
      onClick={() => {
        if (isRecording) {
          stopRecording();
        } else {
          startRecording(recordingWebhookUrl);
        }
      }}
      tooltipTitle={isRecording ? "Stop Recording" : "Start Recording"}
      isFocused={isRecording}
      disabled={!participantCanToggleRecording}
    />
  );
};

const WebcamBTN = () => {
  const theme = useTheme();
  const mMeeting = useMeeting({});
  const { selectedWebcam } = useMeetingAppContext();

  const [selectedDeviceId, setSelectedDeviceId] = useState(selectedWebcam.id);

  const [downArrow, setDownArrow] = useState(null);
  const [webcams, setWebcams] = useState([]);

  const localWebcamOn = mMeeting?.localWebcamOn;
  const toggleWebcam = mMeeting?.toggleWebcam;
  const changeWebcam = mMeeting?.changeWebcam;

  const handleClick = (event) => {
    setDownArrow(event.currentTarget);
  };

  const handleClose = () => {
    setDownArrow(null);
  };

  const getWebcams = async (mGetWebcams) => {
    const webcams = await mGetWebcams();

    webcams && webcams?.length && setWebcams(webcams);
  };

  const tollTipEl = useRef();

  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      ref={tollTipEl}
    >
      <OutlineIconButton
        btnID={"btnWebcam"}
        tooltipTitle={localWebcamOn ? "Turn off webcam" : "Turn on webcam"}
        isFocused={localWebcamOn}
        Icon={localWebcamOn ? VideocamIcon : VideocamOffIcon}
        onClick={toggleWebcam}
        focusBGColor={"#ffffff33"}
        focusIconColor={theme.palette.common.white}
        renderRightComponent={() => {
          //   <Tooltip
          //   placement="bottom"
          //   title={localWebcamOn ? "Change webcam" : null}
          // >
          //   <IconButton
          //     disabled={!localWebcamOn}
          //     onClick={(e) => {
          //       getWebcams(mMeeting?.getWebcams);
          //       handleClick(e);
          //     }}
          //     size={"small"}
          //   >
          //     <ArrowDropDownIcon fontSize={"small"} />
          //   </IconButton>
          // </Tooltip>
          return (
            <IconButton
              // disabled={!localWebcamOn}
              onClick={(e) => {
                getWebcams(mMeeting?.getWebcams);
                handleClick(e);
              }}
              size={"small"}
            >
              <ArrowDropDownIcon fontSize={"small"} />
            </IconButton>
          );
        }}
      />
      <Popover
        container={tollTipEl.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        anchorEl={tollTipEl.current}
        open={Boolean(downArrow)}
        onClose={handleClose}
      >
        <MenuList>
          {webcams.map(({ deviceId, label }, index) => (
            <MenuItem
              key={`output_webcams_${deviceId}`}
              selected={deviceId === selectedDeviceId}
              onClick={() => {
                handleClose();
                setSelectedDeviceId(deviceId);
                changeWebcam(deviceId);
              }}
            >
              {label || `Webcam ${index + 1}`}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </Box>
  );
};
const EndCallBTN = () => {
  const mMeeting = useMeeting({});
  const classes = useStyles();

  const [isEndMeeting, setIsEndMeeting] = useState(false);
  const { endCallContainerRef, canEndMeeting } = useMeetingAppContext();

  const sendChatMessage = mMeeting?.sendChatMessage;

  const leave = mMeeting?.leave;
  const end = mMeeting?.end;

  const tollTipEl = useRef();

  const theme = useTheme();

  const [downArrow, setDownArrow] = useState(null);

  const handleClick = (event) => {
    setDownArrow(event.currentTarget);
  };

  const handleClose = () => {
    setDownArrow(null);
  };

  return (
    <Box
      ref={tollTipEl}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <OutlineIconButton
        ref={endCallContainerRef}
        // tooltipTitle={"Leave call"}
        bgColor={theme.palette.error.main}
        Icon={EndCall}
        onClick={(e) => {
          canEndMeeting ? handleClick(e) : leave();
        }}
      />
      {canEndMeeting && (
        <>
          <Popover
            container={tollTipEl.current}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            anchorEl={tollTipEl.current}
            open={Boolean(downArrow)}
            onClose={handleClose}
            classes={{
              paper: classes.popoverBorder,
            }}
          >
            <MenuList>
              <MenuItem
                key={`leave`}
                onClick={() => {
                  leave();
                }}
              >
                <Box style={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    style={{
                      backgroundColor: theme.palette.common.sidePanel,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 42,
                      width: 42,
                      borderRadius: 4,
                    }}
                  >
                    <LeaveMeetingIcon height={22} width={22} />
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "column",
                      marginLeft: 12,
                      justifyContent: "center",
                    }}
                  >
                    <Typography style={{ fontSize: 14 }}>Leave</Typography>
                    <Typography
                      color={"textSecondary"}
                      style={{ fontSize: "0.9rem" }}
                    >
                      Only you will leave the call.
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
              <MenuItem
                style={{ marginTop: 4 }}
                key={`end`}
                onClick={() => {
                  setIsEndMeeting(true);
                }}
              >
                <Box style={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    style={{
                      backgroundColor: theme.palette.common.sidePanel,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 42,
                      width: 42,
                      borderRadius: 4,
                    }}
                  >
                    <EndCallIcon />
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      marginLeft: 12,
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography style={{ fontSize: 14, lineHeight: 1.5 }}>
                      End
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "0.9rem",
                      }}
                      color={"textSecondary"}
                    >
                      End call for all participants.
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            </MenuList>
          </Popover>

          <ConfirmBox
            open={isEndMeeting}
            title={"Are you sure to end this call for everyone?"}
            successText={"End Call"}
            onSuccess={() => {
              sendChatMessage(JSON.stringify({ type: "END_CALL", data: {} }));
              setTimeout(() => {
                end();
              }, 1000);
            }}
            rejectText="Cancel"
            onReject={() => {
              setIsEndMeeting(false);
            }}
          />
        </>
      )}
    </Box>
  );
};

const ToggleVBBtn = () => {
  const { sideBarMode, toggleBG, setTooglebg, setSideBarMode } =
    useMeetingAppContext();
  const mMeeting = useMeeting({});
  const toggleWebcam = mMeeting?.toggleWebcam;

  return (
    <>
      <OutlineIconButton
        tooltipTitle={"Virtual Background"}
        Icon={Crop}
        isFocused={sideBarMode === sideBarModes.VISUAL}
        onClick={() => {
          // setTooglebg(!toggleBG);
          // setSideBarMode(sideBarModes === "VISUAL" ? null : "VISUAL");
          setSideBarMode((s) =>
            s === sideBarModes.VISUAL ? null : sideBarModes.VISUAL
          );
          // toggleWebcam();
          // setTimeout(() => {
          //   toggleWebcam();
          // }, 1500);
        }}
      />
    </>
  );
};

const SpeedtestIcon = () => {
  const { sideBarMode, setSideBarMode, setExternalvideoPlayer } =
    useMeetingAppContext();

  return (
    <OutlineIconButton
      tooltipTitle={"Speed Test"}
      Icon={NetworkWifi}
      isFocused={sideBarMode === sideBarModes.ACTIVITIES}
      onClick={() => {
        setSideBarMode((s) =>
          s === sideBarModes.ACTIVITIES ? null : sideBarModes.ACTIVITIES
        );
      }}
    />
  );
  // return (
  //   <>
  //     {/* <OutlineIconButton
  //       tooltipTitle={"Speed Test"}
  //       Icon={NetworkWifi}
  //       // isFocused={toggleBG}
  //       disabled={false}
  //       onClick={() => {
  //         setShow(true);
  //       }}
  //       // onClick={() => {
  //       //   toggleWebcam();
  //       //   setTooglebg(!toggleBG);

  //       //   setTimeout(() => {
  //       //     toggleWebcam();
  //       //   }, 2000);
  //       // }}
  //     /> */}
  //   </>
  // );
};

const ExternalVideoPlayerIcon = () => {
  const {
    sideBarMode,
    setSideBarMode,
    setExternalvideoPlayer,
    externalVideoplayer,
  } = useMeetingAppContext();
  const mMeeting = useMeeting();
  // Mmeeting?.meeting?.on("video-state-changed", handleExternalvideoplayer);

  return (
    <OutlineIconButton
      tooltipTitle={"Video Player"}
      Icon={FeaturedVideo}
      isFocused={externalVideoplayer.started}
      onClick={() => {
        if (externalVideoplayer.started) {
          setExternalvideoPlayer({
            started: false,
            link: null,
          });
          mMeeting?.stopVideo();
        } else {
          setSideBarMode((s) =>
            s === sideBarModes.VIDEO_PLAYER ? null : sideBarModes.VIDEO_PLAYER
          );
        }
      }}
    />
  );
};

const LiveStreamingIcon = () => {
  const { setstartLivestreaming, startliveStreaming } = useMeetingAppContext();
  const mMeeting = useMeeting();
  let [searchParams, setSearchParams] = useSearchParams();
  return (
    <OutlineIconButton
      Icon={ScreenRecording}
      onClick={async () => {
        if (!startliveStreaming) {
          if (searchParams.get("stream")?.length > 5) {
            mMeeting?.startLivestream([
              {
                url: "rtmps://global-live.mux.com:443/app",
                streamKey: searchParams.get("stream"),
              },
            ]);
          } else {
            toast.error("Please provide Stream key on url");
          }
          // const streaming = await axios.get(
          //   "https://nowevents.herokuapp.com/live-stream"
          // );

          // if (streaming?.data?.data?.stream_key) {
          //   mMeeting?.startLivestream([
          //     {
          //       url: "rtmps://global-live.mux.com:443/app",
          //       streamKey: streaming?.data?.data?.stream_key,
          //     },
          //   ]);
          // }
        } else {
          mMeeting?.stopLivestream();
        }
      }}
      tooltipTitle={!startliveStreaming ? "Start Streaming" : "Stop Streaming"}
      isFocused={startliveStreaming}
    />
  );
};

const LeaveMettingButton = () => {
  const mMeeting = useMeeting({});
  const classes = useStyles();

  const [isEndMeeting, setIsEndMeeting] = useState(false);
  const { endCallContainerRef, canEndMeeting } = useMeetingAppContext();

  const sendChatMessage = mMeeting?.sendChatMessage;

  const leave = mMeeting?.leave;
  const end = mMeeting?.end;

  const tollTipEl = useRef();

  const theme = useTheme();

  const [downArrow, setDownArrow] = useState(null);

  const handleClick = (event) => {
    setDownArrow(event.currentTarget);
  };

  const handleClose = () => {
    setDownArrow(null);
  };

  return (
    <Box
      ref={tollTipEl}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Button
        onClick={(e) => {
          canEndMeeting ? handleClick(e) : leave();
        }}
        ref={endCallContainerRef}
        variant="contained"
        style={{
          backgroundColor: "#d32f2f",
          color: "white",
          margin: theme.spacing(0, 0),
          // : isMDOnly
          // ? theme.spacing(0, 1)
          padding: 7,
          borderRadius: 4,
          width: "auto",
          textTransform: "none",
          // fontWeight:"bold",
          fontSize: 15,
        }}
        size={"small"}
        fullWidth={false}
        // className={classes.btnCreate}
        startIcon={<EndCall style={{ height: 28, width: 28 }} />}
      >
        Leave meeting
      </Button>
      {canEndMeeting && (
        <>
          <Popover
            container={tollTipEl.current}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            anchorEl={tollTipEl.current}
            open={Boolean(downArrow)}
            onClose={handleClose}
            classes={{
              paper: classes.popoverBorder,
            }}
          >
            <MenuList>
              <MenuItem
                key={`leave`}
                onClick={() => {
                  leave();
                }}
              >
                <Box style={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    style={{
                      backgroundColor: theme.palette.common.sidePanel,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 42,
                      width: 42,
                      borderRadius: 4,
                    }}
                  >
                    <LeaveMeetingIcon height={22} width={22} />
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "column",
                      marginLeft: 12,
                      justifyContent: "center",
                    }}
                  >
                    <Typography style={{ fontSize: 14 }}>Leave</Typography>
                    <Typography
                      color={"textSecondary"}
                      style={{ fontSize: "0.9rem" }}
                    >
                      Only you will leave the call.
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
              <MenuItem
                style={{ marginTop: 4 }}
                key={`end`}
                onClick={() => {
                  setIsEndMeeting(true);
                }}
              >
                <Box style={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    style={{
                      backgroundColor: theme.palette.common.sidePanel,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 42,
                      width: 42,
                      borderRadius: 4,
                    }}
                  >
                    <EndCallIcon />
                  </Box>
                  <Box
                    style={{
                      display: "flex",
                      marginLeft: 12,
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography style={{ fontSize: 14, lineHeight: 1.5 }}>
                      End
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "0.9rem",
                      }}
                      color={"textSecondary"}
                    >
                      End call for all participants.
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            </MenuList>
          </Popover>

          <ConfirmBox
            open={isEndMeeting}
            title={"Are you sure to end this call for everyone?"}
            successText={"End Call"}
            onSuccess={() => {
              sendChatMessage(JSON.stringify({ type: "END_CALL", data: {} }));
              setTimeout(() => {
                end();
              }, 1000);
            }}
            rejectText="Cancel"
            onReject={() => {
              setIsEndMeeting(false);
            }}
          />
        </>
      )}
      {/* </OutlineIconButton> */}
    </Box>
  );
};
const ShareMeetingIcon = () => {
  return (
    <CopyToClipboard
      text={window.location.href?.replace(/&interacted.*$/i, "")}
      onCopy={() => toast.success("Link copied successfully")}
    >
      <OutlineIconButton
        Icon={Share}
        onClick={async () => {}}
        tooltipTitle={"Copy link"}
      />
    </CopyToClipboard>
  );
};

const TopBar = ({ topBarHeight }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [defaultBrandLogoUrl, setDefaultBrandLogoUrl] = useState(null);
  let permission;
  if (localStorage.getItem("meetingToken")) {
    var decodedHeader = jwt_decode(localStorage.getItem("meetingToken"));
    permission = decodedHeader;
  }

  const {
    chatEnabled,
    screenShareEnabled,
    pollEnabled,
    whiteboardEnabled,
    participantCanToggleSelfWebcam,
    participantCanToggleSelfMic,
    raiseHandEnabled,
    recordingEnabled,
    brandingEnabled,
    brandLogoURL,
    brandName,
    participantCanLeave,
    poweredBy,
    downloadKb,
    setDownloadKB,
    uploadKb,
    setUploadKB,
    sideBarMode,
    setProgressInternetSpeed,
    progressinternetSpeed,

    setmeasurementText,
  } = useMeetingAppContext();

  const handleClickFAB = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseFAB = () => {
    setAnchorEl(null);
  };

  const isMobile = useIsMobile();
  const isTab = useIsTab();

  const theme = useTheme();
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  const topBarButtonTypes = useMemo(
    () => ({
      // END_CALL: "END_CALL",
      ACTIVITIES: "ACTIVITIES",
      CHAT: "CHAT",
      PARTICIPANTS: "PARTICIPANTS",
      SCREEN_SHARE: "SCREEN_SHARE",
      WEBCAM: "WEBCAM",
      MIC: "MIC",
      RAISE_HAND: "RAISE_HAND",
      RECORDING: "RECORDING",
      WHITEBOARD: "WHITEBOARD",
      VB: "VB",
      SPEED: "SPEED",
      VIDEO_PLAYER: "VIDEO_PLAYER",
      LIVE_STREAM: "LIVE_STREAM",
      LEAVE_MEETING: "LEAVE_MEETING",
      SHARE: "SHARE",
    }),
    []
  );

  const topBarIcons = useMemo(() => {
    const arr = [];
    arr.unshift([topBarButtonTypes.LEAVE_MEETING]);
    // arr.unshift([topBarButtonTypes.VB]);
    arr.unshift([topBarButtonTypes.SHARE]);
    if (permission?.permissions?.includes("allow_join")) {
     
      arr.unshift([topBarButtonTypes.VIDEO_PLAYER]);
      arr.unshift([topBarButtonTypes.SPEED]);

      arr.unshift([topBarButtonTypes.LIVE_STREAM]);
    }

    // if (participantCanLeave) {
    //   arr.unshift([topBarButtonTypes.END_CALL]);
    // }

    const arrSideBar = [];

    if (pollEnabled || whiteboardEnabled) {
      arrSideBar.unshift(topBarButtonTypes.ACTIVITIES);
    }
    if (chatEnabled) {
      arrSideBar.unshift(topBarButtonTypes.CHAT);
    }
    arrSideBar.unshift(topBarButtonTypes.PARTICIPANTS);

    arr.unshift(arrSideBar);

    const arrMedia = [];
    if (screenShareEnabled) {
      arrMedia.unshift(topBarButtonTypes.SCREEN_SHARE);
    }
    if (participantCanToggleSelfWebcam) {
      arrMedia.unshift(topBarButtonTypes.WEBCAM);
    }
    if (participantCanToggleSelfMic) {
      arrMedia.unshift(topBarButtonTypes.MIC);
    }

    if (arrMedia.length) {
      arr.unshift(arrMedia);
    }

    const utilsArr = [];

    if (raiseHandEnabled) {
      utilsArr.unshift(topBarButtonTypes.RAISE_HAND);
    }

    if (recordingEnabled) {
      utilsArr.unshift(topBarButtonTypes.RECORDING);
    }

    if (whiteboardEnabled) {
      utilsArr.unshift(topBarButtonTypes.WHITEBOARD);
    }

    if (utilsArr.length) {
      arr.unshift(utilsArr);
    }

    return arr;
  }, [
    participantCanToggleSelfMic,
    participantCanToggleSelfWebcam,
    screenShareEnabled,
    pollEnabled,
    whiteboardEnabled,
    chatEnabled,
    raiseHandEnabled,
    topBarButtonTypes,
    recordingEnabled,
  ]);
  const [show, setShow] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#141415",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    background: "#141415",
  };
  // SomApi.onTestCompleted = onTestCompleted;
  // SomApi.onError = onError;

  const [pecentDone, setPercentDone] = useState(0);
  const [velocity, setVelocity] = useState(0);
  const [download, setDownload] = useState("Download");
  const [upload, setUpload] = useState("Upload");

  // const [downloadKb, setDownloadKB] = useState(0);
  // const [uploadKb, setUploadKB] = useState(0);

  useEffect(() => {
    if (sideBarMode === "ACTIVITIES") {
      window.SomApi.account = "SOM61c1cbcbee025";
      window.SomApi.domainName = "nowevents.vercel.app";
      window.SomApi.onTestCompleted = onTestCompleted;
      window.SomApi.onError = onError;
      window.SomApi.onProgress = onProgress;
      window.SomApi.startTest();
    }
  }, [sideBarMode]);

  const onTestCompleted = (e) => {
    let total = parseFloat(e?.download) + parseFloat(e?.upload);
    setVelocity(total);

    let downloadInKB = e.download * 1024;

    let speedTextDownload;
    setDownloadKB(downloadInKB);
    if (downloadInKB > 1000 && e?.latency < 150) {
      speedTextDownload = "Your network is good";
    } else if (downloadInKB > 600 && e?.latency < 150) {
      speedTextDownload = "Your network is good";
    } else if (downloadInKB > 300 && e?.latency < 150) {
      speedTextDownload = "Your network is good";
    } else if (downloadInKB > 350 && e?.latency > 150) {
      speedTextDownload = "Your network is bad";
    } else if (downloadInKB > 250 && e?.latency > 150) {
      speedTextDownload = "Your network is bad";
    } else if (downloadInKB > 150 && e?.latency > 150) {
      speedTextDownload = "Your network is bad";
    }
    setDownload(speedTextDownload);
    setmeasurementText(speedTextDownload);

    let uploadInKB = e?.upload * 1024;

    let speedTextUpload;
    setUploadKB(uploadInKB);

    // if (uploadInKB > 1000 && e?.latency < 150) {
    //   speedTextUpload = "Excellent Upload Speed";
    // } else if (uploadInKB > 600 && e?.latency < 150) {
    //   speedTextUpload = "Excellent Upload Speed";
    // } else if (uploadInKB > 300 && e?.latency < 150) {
    //   speedTextUpload = "Excellent Upload Speed";
    // } else if (uploadInKB > 350 && e?.latency > 150) {
    //   speedTextUpload = "Acceptable Upload Speed";
    // } else if (uploadInKB > 250 && e?.latency > 150) {
    //   speedTextUpload = "Acceptable Upload Speed";
    // } else if (uploadInKB > 150 && e?.latency > 150) {
    //   speedTextUpload = "Acceptable Upload Speed";
    // }
    setUpload(speedTextUpload);
  };
  const onError = (e) => {
    toast.error(e?.message);
  };
  const onProgress = (progress) => {
    setProgressInternetSpeed(progress.percentDone * 2);
    setPercentDone(progress.percentDone * 2);
    setVelocity(progress.percentDone);
  };
  return isTab || isMobile ? (
    <Box
      style={{
        height: topBarHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
        borderTop: "1px solid #ffffff33",
      }}
    >
      {participantCanLeave && (
        <Box>
          <EndCallBTN />
        </Box>
      )}
      {participantCanToggleSelfMic && (
        <Box ml={2}>
          <MicBTN />
        </Box>
      )}
      {participantCanToggleSelfWebcam && (
        <Box ml={2}>
          <WebcamBTN />
        </Box>
      )}
      {isPortrait ? (
        recordingEnabled ? (
          <Box ml={2}>
            <RecordingBTN />
          </Box>
        ) : chatEnabled ? (
          <Box ml={2}>
            <ChatBTN />
          </Box>
        ) : null
      ) : (
        <Box ml={2}>
          <ChatBTN />
        </Box>
      )}
      {!isPortrait && recordingEnabled && (
        <Box ml={2}>
          <RecordingBTN />
        </Box>
      )}
      <Box ml={2}>
        <OutlineIconButton
          Icon={Boolean(anchorEl) ? CloseIcon : MoreHorizIcon}
          isFocused={anchorEl}
          onClick={handleClickFAB}
        />
      </Box>
      <Popover
        container={anchorEl?.current}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        className={classes.popover}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseFAB}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box>
          {raiseHandEnabled && (
            <Box mb={1.2}>
              <RaiseHandBTN onClick={handleCloseFAB} />
            </Box>
          )}
          <Box mb={1.2}>
            <ParticipantsBTN onClick={handleCloseFAB} />
          </Box>
          {/* {(pollEnabled || whiteboardEnabled) && (
            <Box mb={1.2}>
              <ActivitiesBTN onClick={handleCloseFAB} />
            </Box>
          )} */}
          {screenShareEnabled && (
            <Box mb={1.2}>
              <ScreenShareBTN onClick={handleCloseFAB} />
            </Box>
          )}
          {isPortrait && recordingEnabled && chatEnabled && (
            <Box mb={1.2}>
              <ChatBTN onClick={handleCloseFAB} />
            </Box>
          )}
        </Box>
      </Popover>
    </Box>
  ) : (
    <Box
      style={{
        height: topBarHeight,
        display: "flex",
        alignItems: "center",
        // justifyContent: "space-between",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
        borderBottom: "1px solid #ffffff33",
        position: "relative",
      }}
    >
      <Modal
        open={show}
        onClose={() => {
          setShow(!show);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ReactSpeedometer
            value={pecentDone}
            needleTransitionDuration={4000}
            needleTransition="easeElastic"
            currentValueText={"Speed Test"}
            currentValuePlaceholderStyle="#{value}"
            textColor="#FFF"
            startColor="#F4552C"
            endColor="#F9F9F9"
            needleColor="#989898"
            // needleTransitionDuration={4000}
            // needleTransition="easeElastic"
          />
          <div className="card">
            <div className="total-box flex-total-centered">
              <div className="total">
                <div className={classes?.totalSpeed}>
                  {velocity.toFixed(2)} Mbps
                </div>
                <div className={classes?.totalSpeed}>{download}</div>
                <div className={classes?.totalSpeed}>{upload}</div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Box
        style={{
          display: "flex",
          height: topBarHeight,
          paddingLeft: theme.spacing(2),
          position: "relative",
          alignItems: "center",
        }}
      >
        {brandingEnabled && (
          <>
            <img
              alt={"App Logo"}
              style={{
                display: "inline-block",
                height: topBarHeight - theme.spacing(2),
              }}
              src={
                defaultBrandLogoUrl ||
                brandLogoURL ||
                `https://static.zujonow.com/prebuilt/videosdk_logo_circle.png`
              }
              onError={() => {
                setDefaultBrandLogoUrl(
                  `https://static.zujonow.com/prebuilt/videosdk_logo_circle.png`
                );
              }}
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              ml={1}
            >
              <Typography
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                }}
              >
                {brandName}
              </Typography>
              {poweredBy ? (
                <Typography
                  style={{
                    fontSize: "0.9rem",
                    wordBreak: "break-all",
                    display: "flex",
                    alignItems: "center",
                  }}
                  color={"textSecondary"}
                >
                  Powered by&nbsp;
                  <Link
                    style={{ textDecorationColor: "#fa3a57" }}
                    target={"_blank"}
                    href={"https://videosdk.live"}
                  >
                    <Typography
                      style={{
                        color: "#fa3a57",
                        textTransform: "lowercase",
                        fontSize: "0.9rem",
                      }}
                    >
                      videosdk.live
                    </Typography>
                  </Link>
                </Typography>
              ) : null}
            </Box>
          </>
        )}
      </Box>

      <Box className={classes.row} p={2}>
        {topBarIcons.map((row, i) => {
          return (
            <React.Fragment key={`topbar_controls_i_${i}`}>
              {i !== 0 && (
                <Box
                  style={{
                    backgroundColor: "#ffffff33",
                    width: 1,
                    height: topBarHeight - theme.spacing(1.5),
                    flex: 1,
                  }}
                />
              )}
              <Box
                ml={i === 0 ? 0 : 3}
                mr={i === topBarIcons.length - 1 ? 0 : 3}
                className={classes.row}
              >
                {row.map((buttonType, j) => {
                  return (
                    <Box key={`topbar_controls_j_${j}`} ml={j === 0 ? 0 : 1.5}>
                      {buttonType === topBarButtonTypes.RAISE_HAND ? (
                        <RaiseHandBTN />
                      ) : buttonType === topBarButtonTypes.MIC ? (
                        <MicBTN />
                      ) : buttonType === topBarButtonTypes.WEBCAM ? (
                        <WebcamBTN />
                      ) : buttonType === topBarButtonTypes.SCREEN_SHARE ? (
                        <ScreenShareBTN />
                      ) : buttonType === topBarButtonTypes.PARTICIPANTS ? (
                        <ParticipantsBTN />
                      ) : buttonType === topBarButtonTypes.CHAT ? (
                        <ChatBTN />
                      ) : // buttonType === topBarButtonTypes.ACTIVITIES ? (
                      //   <ActivitiesBTN />
                      // )
                      // buttonType === topBarButtonTypes.END_CALL ? (
                      //   <EndCallBTN />
                      // )

                      // :

                      buttonType === topBarButtonTypes.RECORDING ? (
                        <RecordingBTN />
                      ) : buttonType === topBarButtonTypes.WHITEBOARD ? (
                        <WhiteBoardBTN />
                      ) : // : buttonType === topBarButtonTypes.VB ? (
                      //   <ToggleVBBtn />
                      buttonType === topBarButtonTypes.SPEED ? (
                        <SpeedtestIcon />
                      ) : buttonType === topBarButtonTypes.VIDEO_PLAYER ? (
                        <ExternalVideoPlayerIcon />
                      ) : buttonType === topBarButtonTypes.LIVE_STREAM ? (
                        <LiveStreamingIcon />
                      ) : buttonType === topBarButtonTypes.LEAVE_MEETING ? (
                        <LeaveMettingButton />
                      ) : buttonType === topBarButtonTypes.SHARE ? (
                        <ShareMeetingIcon />
                      ) : null}
                    </Box>
                  );
                })}
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default TopBar;
